import { render } from "./ProProdutosView.vue?vue&type=template&id=08df346a&scoped=true"
import script from "./ProProdutosView.vue?vue&type=script&lang=js"
export * from "./ProProdutosView.vue?vue&type=script&lang=js"

import "./ProProdutosView.vue?vue&type=style&index=0&id=08df346a&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08df346a"]])

export default __exports__